<template>
    <SquareBtn color="warning"
               data-component="PayBalanceButton"
               @click="$emit('click')">
        {{ l(isRefund ? 'ORDER_DETAILS.ISSUE_REFUND' : 'ORDER_DETAILS.PAY_BALANCE') }}
        {{ order.remainingBalance ? '(' + currencyFilter(order.remainingBalance) + ')' : '' }}
    </SquareBtn>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';

export default {
    components: { SquareBtn },

    props: {
        order: {
            type: Object,
            required: true,
        },

        isRefund: {
            type: Boolean,
            required: true,
        },
    },

    emits: ['click'],
};
</script>

<style scoped lang="less">

</style>
